<template>
  <div>
    <surveys-table
      surveyName="EASI"
      surveyCode="EASI"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_EASI,
        viewDetail: permissions.SEE_DETAIL_SURVEY_EASI,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
